import store from "@/core/store"
import {GET_ACCOUNT} from "@/core/store/modules/account/constants"

export default function auth({next, router}) {
    if (!store.getters.isAuthenticated) {
        let route = {
            name: 'login',
            query: {}
        }
        if (window.location.pathname !== '/') {
            route.query.redirect = window.location.href
        }
        return router.push(route).catch(() => {
        });
    }

    if (!store.getters.hasAccount) {
        store.dispatch(GET_ACCOUNT).then((response) => {
            return next()
        }).catch(() => {
        })
    } else {
        return next();
    }

}